import AmazonStore from './AmazonStore.svg'
import BabylistStore from './BabylistStore.svg'
import GenericStore from './GenericStore.svg'
import TargetStore from './TargetStore.svg'
import WalmartStore from './WalmartStore.svg'

export { AmazonStore, BabylistStore, GenericStore, TargetStore, WalmartStore }
